export default function HrgsLogMonitoringErrorRoutes(staticTitle) {
    return [
        {
            path: '/hrgs/traveloka-transaction',
            name: 'hrgs-traveloka-transaction',
            meta: {
                title: `${staticTitle} - HR & GS`
            },
            component: () => {
                return import('@/views/hrgs/traveloka-transaction/Index.vue');
            }
        }
    ];
}
